import bundle from './bundle';
import ThemeSwitcherButton from './theme-switcher-button';

const plugin = {
  pluginName: 'Theme Switcher',
  enabled: true,
  components:[{
    component: ThemeSwitcherButton,
    region: 'left-sidebar-bottom',
    sortOrder: 30
  }],
  bundle: bundle
}

// for use whith rollup.js for bundling the plugin externally
if(window.store){
  window.store.integrateBundles(plugin.bundle);
  window.store.doAddPluginComponents(plugin.components);
}

export default plugin;